<template>
  <div>
    <!-- 内容区 -->
    <div class="mapbox">
      <div class="bg">
        <img src="@/assets/image/tl.png" alt="" />
        <img src="@/assets/image/tr.png" alt="" />
        <img src="@/assets/image/bl.png" alt="" />
        <img src="@/assets/image/br.png" alt="" />
      </div>
      <el-radio-group v-model="brandPutSwitch" size="small" class="bottom-left"
        @change="filterSite('重点',brandPutSwitch)" v-if="isHidekeynote">
        <el-radio label="" border>全部重点区域站点</el-radio>
        <el-radio :label="1" border>重点区域可投放站点</el-radio>
        <el-radio :label="0" border>重点区域不可投放站点</el-radio>
      </el-radio-group>
      <el-popover class="top-right" popper-class="statbox" placement="bottom-end" trigger="click" v-if="isHidekeynote">
        <div v-for="(item,index) in marjorSite" :key="index">
          <span>{{index==0?'重点可投放':'重点不可投放'}}</span>
          <span @click="filterSite2(index==1?0:1,5)">
            {{item['站点总数']}}
            <p>站点总数</p>
          </span>
          <span @click="filterSite2(index==1?0:1,2)">
            {{item['满桩']}}
            <p>满桩</p>
          </span>
          <span @click="filterSite2(index==1?0:1,3)">
            {{item['偏多']}}
            <p>偏多</p>
          </span>
          <span @click="filterSite2(index==1?0:1,1)">
            {{item['正常']}}
            <p>正常</p>
          </span>
          <span @click="filterSite2(index==1?0:1,4)">
            {{item['偏少']}}
            <p>偏少</p>
          </span>
          <span @click="filterSite2(index==1?0:1,0)">
            {{item['空桩']}}
            <p>空桩</p>
          </span>
        </div>
        <el-button slot="reference" size="mini" class="stat">
          <img src="@/assets/image/统计.png" alt="">统计
        </el-button>
      </el-popover>
      <amap ref="myMap" :isHideLayer.sync="isHideLayer" :isHidekeynote.sync="isHidekeynote"
        :isHideOverlay.sync="isHideOverlay" :ratioSites="ratioSites" :userLevel="userLevel" :fullPileNum="fullPileNum"
        :tableData="tableData" :tableDataBrands="tableDataBrands" @clearMapTimer="clearMapTimer"
        @togglekeynote="togglekeynote" :mapData="map" @refreshCenter="refreshCenter" @refreshMap="refreshMap"
        @onInfoWindowClick="onShowBike" :selfAddress="selfAddress" :selfAreaId="selfAreaId" :currMap="currMap"
        :sizezoom="zoom" />
      <div class="station-search">
        <station-search ref="stationSearch" :selfAreaId="selfAreaId" @search="onSearch" styleIndex="dark" />
      </div>
      <div class="bike-company" v-if="illegalBikes && illegalBikes.length">
        <el-select class="dark-select" @change="companyOfIllegalBikeChange" v-model="companyOfIllegalBikeValue"
          :popper-append-to-body="false">
          <el-option v-for="item in companyOfIllegalBikes" :key="item.name" :label="`${item.name}(${item.num})`"
            :value="item.name">
          </el-option>
        </el-select>
      </div>
      <el-popover class="right-icon" popper-class="right-dark" placement="top-end" trigger="manual"
        :visible-arrow="false" v-model="visible">
        <p @click="changeSiteSize(0)" :class="{ active: size == 0 }">
          全部站点 <i class="el-icon-check"></i>
        </p>
        <p @click="changeSiteSize(200)" :class="{ active: size == 200 }">
          200个站点 <i class="el-icon-check"></i>
        </p>
        <p @click="changeSiteSize(50)" :class="{ active: size == 50 }">
          50个站点 <i class="el-icon-check"></i>
        </p>
        <img src="@/assets/image/站点选择.png" slot="reference" @click="visible = !visible"  title="站点" />
      </el-popover>
    </div>
    <!-- 一级弹窗 -->
    <w-dialog ref="w-dialog" :title="dialogTitle" width="50%" :isShowFooter="false" @handleClose="handleClose"
      @handleCloseRight="handleClose" @onSure="handleClose" @jjSearch="jjSearch" className="i-dialog">
      <template v-slot:content>
        <component v-bind:is="currentComponent" :fullPileNum="fullPileNum" :detail="detail" :siteMessage="siteMessage"
          :companyData="companyData" :historyData="historyData" :typeName="typeName" :currentData="detailSimple"
          @onShowDialog2="onShowDialog2" @jjSearch="jjSearch" />
      </template>
    </w-dialog>
    <!-- 二级弹窗 w-dialog2 详情 -->
    <w-dialog ref="w-dialog2" :title="dialogTitle2" width="50%" :isShowFooter="false" @handleCloseRight="handleClose2"
      @handleClose="handleClose2" className="i-dialog">
      <template v-slot:content>
        <div class="dialog-content mapbox-dialog-content" v-if="subType === 'bikesEcharts'">
          <div class="bikesEcharts-header">
            站点名称：<span class="mr40">{{
              siteInfoData && siteInfoData.siteName
            }}</span>
            车位数量：
            <span>{{ siteInfoData && siteInfoData.siteBikeCeiling }}</span>
          </div>
          <site-chart :selfAreaId="selfAreaId" :realHeight="500" dark :siteId="siteInfoData.siteId">
          </site-chart>
        </div>
        <div class="dialog-content" v-if="subType === 'bikes'">
          <w-table v-if="tableData2 && tableData2.length" v-loading.body="tableLoading2" :data-list="tableData2"
            :columns="staticData2[subType].columns" :pageNo="formData2.pageNum" :pageSize="formData2.pageSize"
            :total="total2" :bPagination="needPagination2" @pageNoChange="pageNoChange2"
            @pageSizeChange="pageSizeChange2">
            <template slot-scope="props" slot="cell">
              <span v-if="props.column.label === '序号'">{{
                props.index + 1 + (formData2.pageNum - 1) * formData2.pageSize
              }}</span>
              <span v-else-if="props.column.label === '品牌'">{{
                  siteInfoData.brandId
                    ? siteInfoData.brandName
                    : props.row[props.column.property]
                }}
              </span>
              <span :class="{ 'sp-red': props.row[props.column.property] === 1 }"
                v-else-if="props.column.label === '合法性'">{{
                  props.row[props.column.property] === 0
                    ? "合法"
                    : props.row[props.column.property] === 1
                    ? "非法"
                    : ""
                }}</span>
              <span v-else>{{ props.row[props.column.property] }}</span>
            </template>
          </w-table>
          <div v-else>暂无信息</div>
        </div>
        <div class="dialog-content" v-else>
          <el-button v-if="
              ['brandOperationNum', 'brandBikeNum', 'brandEBikeNum'].includes[
                subType
              ]
            " type="default" style="small">导出数据</el-button>
          <w-table v-if="tableData2 && tableData2.length" v-loading.body="tableLoading2" :data-list="tableData2"
            :columns="staticData2[subType].columns" :pageNo="formData2.pageNum" :pageSize="formData2.pageSize"
            :total="total2" :bPagination="needPagination2" @pageNoChange="pageNoChange2"
            @pageSizeChange="pageSizeChange2">
            <template slot-scope="props" slot="cell">
              <span v-if="props.column.label === '序号'">{{
                props.index + 1 + (formData2.pageNum - 1) * formData2.pageSize
              }}</span>
              <span v-else-if="props.column.label === '工作单位'">
                <span v-if="companyData && companyData.length">{{
                  companyData.find(
                    (it) => Number(it.brandId) === Number(props.row.brandId)
                  )
                    ? companyData.find(
                        (it) => Number(it.brandId) === Number(props.row.brandId)
                      ).brandName
                    : ""
                }}</span>
              </span>
              <span v-else>{{ props.row[props.column.property] }}</span>
            </template>
          </w-table>
        </div>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import Amap from './amap.vue'
import StationSearch from '@/components/DailyDuty/stationSearch.vue'
import StatisticsArea from '@/components/DailyDuty/statisticsArea.vue'
import MessageArea from '@/components/DailyDuty/messageArea.vue'
import TextList from '@/components/Listbox/textList.vue'
import recordList from '@/components/Listbox/recordList.vue'
import notupload from '@/components/Listbox/notupload.vue'
import siteRank from '@/components/Listbox/siteRank.vue'
import TableList from '@/components/Listbox/tableList.vue'
import HistoryList from '@/components/Listbox/historyList.vue'
import MessageList from '@/components/Listbox/messageList.vue'
import WDialog from '@/components/Model/index.vue'
import TextListSlot from '@/components/Listbox/textListSlot.vue'
import WTable from '@/components/Table/index.vue'
import staticData2 from '@/views/CompanyManagement/staticData.js'
import staticData from '../../DailyDuty/staticData.js'
import Api from '@/api'
import {
  mapGetters
} from 'vuex'
import store from '@/store'
import {
  downloadExcel,
  getUrlParam
} from '@/utils/tools.js'
import echarts from 'echarts'
import siteChart from './siteChart.vue'

var AMap = window.AMap
export default {
  name: 'mapbox',
  components: {
    Amap,
    StationSearch,
    StatisticsArea,
    MessageArea,
    WDialog,
    TextList,
    siteRank,
    recordList,
    notupload,
    TableList,
    HistoryList,
    MessageList,
    TextListSlot,
    WTable,
    siteChart
  },
  data() {
    return {
      brandPutSwitch: '',
      marjorSite: [],
      isHideLayer: false,
      isHidekeynote: false,
      isHideOverlay: false,
      illegalBikes: [],
      state: 'start',
      typeName: '',
      detail: {},
      detailSimple: {},
      formData: {
        pageNum: 10,
        pageSize: 10
      },
      total: 660,
      tableLoading: false,
      tableData: null,
      map: [],
      dialogTitle: '',
      currentComponent: '',
      currMap: [],
      mapTimer: null,
      companyData: null, // 品牌信息列表
      // 二级弹窗
      formData2: {
        pageNum: 1,
        pageSize: 10
      },
      total2: 1,
      tableLoading2: false,
      tableData2: null,
      subType: '',
      paramsType: '',
      dialogTitle2: '',
      dialogWidth2: '60%',
      sureBtnText2: '确定',
      isShowFooter2: false,
      needPagination2: false,
      mapCenterTimer: null,
      historyData: [],
      siteInfoData: null, // 消息区 - 查看 - 参数
      companySelect: '',
      companyOptions: [],
      companyRentOptions: [],
      bikesEchartsData: new Date(),
      siteReturnStatisticsData: null,
      siteRentStatisticsData: null,
      beforeUnload_time: null,
      gap_time: null,
      bikeTypeList: [{
        label: '自行车',
        value: 0
      },
      {
        label: '电动车',
        value: 1
      }
      ],
      bikeType: '',
      brand: '',
      brandId: '',
      hourAndPower: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
        21: 0,
        22: 0,
        23: 0,
        24: 0
      },
      hourAndPowerRent: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
        21: 0,
        22: 0,
        23: 0,
        24: 0
      },
      size: 50,
      visible: false,
      isFirst: true,
      debounceTimer: null,
      asyncApiTimer: null,
      mapCenterPosition: null,
      companyOfIllegalBikes: [],
      companyOfIllegalBikeValue: '',
      mapTimerArr: []
    }
  },
  props: {
    abnormalType: {
      default: null,
      type: [String, Number]
    },
    siteMessage: {
      default: () => {
        return []
      },
      type: Array
    },
    statistical: {
      type: Object,
      default () {
        return {}
      }
    },
    mapsite: {
      default: () => {
        return []
      },
      type: Array
    },
    selfAreaId: {
      default: '',
      type: String
    }
  },
  computed: {
    ...mapGetters([
      // "illegalBikes",
      'tableDataBrands',
      'globaleSelfAreaId',
      'ratioSites',
      'userLevel',
      'user',
      'authorization',
      'userSelfAreaId',
      'selfAddress',
      'fullPileNum',
      'userSelectAddressData'
    ]),
    urlParams() {
      if (store.state.user.siteId) {
        return {
          siteId: store.state.user.siteId
        }
      } else {
        return {}
      }
    },
    zoom() {
      // 50的时候17.60 200的时候15.60
      if (this.size == 0) {
        return 14
      } else if (this.size == 50) {
        return 16
      } else if (this.size == 200) {
        return 15
      } else {
        return 14
      }
    },
    aggregation() {
      // 0 - 实体区
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregation
        : undefined
    },
    staticData() {
      return staticData
    },
    staticData2() {
      return staticData2
    }
  },
  watch: {
    selfAreaId(v, o) {
      this.isFirst = true
      this.isHideOverlay = false
      this.isHideLayer = false
      this.isHidekeynote = false
      if (!v) {
        this.$refs.myMap.initMap([])
        this.tableData = {}
        this.$emit('update:statistical', {})
        this.$emit('update:mapsite', [])
        this.$emit('update:siteMessage', [])
        this.illegalBikes = []
        return
      }
      clearTimeout(this.mapTimer)
      this.mapTimer = null
      this.pollingMap(false, true)
    }
  },
  created() {
    const vm = this
    this.isFirst = true
    if (vm.user && vm.user.areaLevel > vm.userLevel) {
      vm.$nextTick(() => {
        vm.$refs.myMap && vm.$refs.myMap.initMap([])
      })
    } else {
      vm.debounce(vm.initData, vm)
    }
  },
  methods: {
    changeSiteSize(size = 0, status = '') {
      this.isHideLayer = false
      this.isHideOverlay = false
      this.isHidekeynote = false
      this.size = size
      this.visible = false
      clearTimeout(this.mapTimer)
      this.mapTimer = null
      this.isFirst = true
      this.$refs.myMap.destroyMap(false)
      this.pollingMap(false, true, status)
      this.$refs.myMap.isShowHeatmap = false
    },
    togglekeynote() {
      // 切换筛选重点区域
      if (!this.isHidekeynote) {
        this.filterSite('重点')
       this.isHidekeynote = true
      } else {
        this.changeSiteSize(50)
      }
    },
    filterSite2(brandPutSwitch, flag) {
      const bikes = this.tableData.map.filter(val => {
        return val.majorSwitch==1&&val.brandPutSwitch===brandPutSwitch&&(val.flag==flag||flag==5)
      })
      this.$refs.myMap && this.$refs.myMap.initMap(bikes, null, null, false)
     this.clearMapTimer('stop')
    },
    filterSite(status, brandPutSwitch = '') {
      if (this.size == 0) {
        const bikes = []
        const marjorSite = [{
          站点总数: 0,
          满桩: 0,
          偏多: 0,
          正常: 0,
          偏少: 0,
          空桩: 0
        }, {
          站点总数: 0,
          满桩: 0,
          偏多: 0,
          正常: 0,
          偏少: 0,
          空桩: 0
        }]
        this.tableData.map.forEach(val => {
          if (status == '重点' && val.majorSwitch == 1) {
            // 进去重点区域逻辑 统计站点车辆情况数据
            if (brandPutSwitch == 1 && val.brandPutSwitch == 1) {
              bikes.push(val)
            } else if (brandPutSwitch === 0 && val.brandPutSwitch === 0) {
              bikes.push(val)
            } else if (brandPutSwitch === '') {
              bikes.push(val)
            }
            val.brandPutSwitch ? marjorSite[0]['站点总数']++ : marjorSite[1]['站点总数']++
            switch (val.flag) {
              case 1:
                val.brandPutSwitch ? marjorSite[0]['正常']++ : marjorSite[1]['正常']++
                break
              case 0:
                val.brandPutSwitch ? marjorSite[0]['空桩']++ : marjorSite[1]['空桩']++
                break
              case 2:
                val.brandPutSwitch ? marjorSite[0]['满桩']++ : marjorSite[1]['满桩']++
                break
              case 3:
                val.brandPutSwitch ? marjorSite[0]['偏多']++ : marjorSite[1]['偏多']++
                console.log(marjorSite)
                break
              case 4:
                val.brandPutSwitch ? marjorSite[0]['偏少']++ : marjorSite[1]['偏少']++
                break
            }
          } else if (status == '站点总数') {
            bikes.push(val)
          } else if (status == '空桩' && val.flag == 0) {
            bikes.push(val)
          } else if (status == '满桩' && val.flag == 2) {
            bikes.push(val)
          } else if (status == '偏多' && val.flag == 3) {
            bikes.push(val)
          } else if (status == '偏少' && val.flag == 4) {
            bikes.push(val)
          } else if (status == '正常' && val.flag == 1) {
            bikes.push(val)
          }
        })
        this.marjorSite = marjorSite
        this.$refs.myMap && this.$refs.myMap.initMap(bikes, null, null, false)
        this.clearMapTimer('stop')
      } else {
        this.changeSiteSize(0, status)
      }
    },
    filterBike(arr) {
      if (this.mapTimer) {
        clearTimeout(this.mapTimer)
      }
      this.$refs.myMap && this.$refs.myMap.initBikeMap2(arr)
    },
    companyOfIllegalBikeChange(val) {
      console.log('companyOfIllegalBikeChange', val)
      let bikes = []
      if (val != '全部') {
        bikes = this.illegalBikes.filter((b) => b.brandName === val)
      } else {
        bikes = this.illegalBikes
      }
      this.$refs.myMap && this.$refs.myMap.initBikeMap(bikes)
    },
    // 获取非法车辆
    getDashboardBike(abnormalType) {
      const vm = this
      if (!this.selfAreaId) {
        return
      }
      if (abnormalType == 'recycleSwitch') {
        const params = {
          selfAreaId: vm.selfAreaId,
          recycleSwitch: 1
        }
        Api.getSiteList(params).then((res) => {
          if (res && res.code === 200) {
            this.illegalBikes = []
            this.companyOfIllegalBikes = []
            vm.$refs.myMap && vm.$refs.myMap.initMap(res.data)
          }
        })
      } else {
        const params = {
          selfAreaId: vm.selfAreaId,
          legality: 1
        }
        if (abnormalType === 1) {
          params.mold = 1
        }
        if (abnormalType === 13) {
          params.mold = 13
        }
        Api.dashboardBike(params).then((res) => {
          if (res && res.code === 200 && res.data.length) {
            res.data = res.data.filter((val) => {
              return val.bikeLat && val.bikeLon
            })
            console.log(res.data)
            vm.$refs.myMap && vm.$refs.myMap.initBikeMap(res.data)
            const illegalBikes = {
              key: 'illegalBikes',
              value: res.data
            }
            // store.commit("user/setUserInfo", illegalBikes);
            this.illegalBikes = res.data
            this.companyOfIllegalBikeValue = ''
            const companyOfIllegalBikeObj = {}
            res.data.forEach((bike) => {
              if (companyOfIllegalBikeObj[bike.brandName]) {
                companyOfIllegalBikeObj[bike.brandName].num++
              } else {
                const obj = {
                  name: bike.brandName,
                  num: 1
                }
                companyOfIllegalBikeObj[bike.brandName] = obj
              }
            })
            vm.companyOfIllegalBikes = [{
              name: '全部',
              num: res.data.length
            }]
            for (const key in companyOfIllegalBikeObj) {
              vm.companyOfIllegalBikes.push(companyOfIllegalBikeObj[key])
            }
          } else {
            if (res.message == '操作成功！' && res.data.length == 0) {
              res.message = '数据为空'
            }
            const illegalBikes = {
              key: 'illegalBikes',
              value: []
            }
            // store.commit("user/setUserInfo", illegalBikes);
            this.illegalBikes = []
            this.companyOfIllegalBikeValue = ''
            vm.$message.warning(res.message || res.data || '数据为空')
          }
        })
      }
    },
    // 初始化
    debounce(method, context, delay) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(function () {
        method.call(context)
      }, delay || 1500)
    },
    async onShowBike(item) {
      // item 站点信息
      if (item.clickType === 1) {
        // 车辆信息
        this.onShowDialog2({
          ...item,
          type: 'bikes',
          bikeType: item.bikeType // 0-自行车，1-电动车
        })
      } else if (item.clickType === 2) {
        // 车辆总数曲线图
        this.onShowDialog2({
          ...item,
          type: 'bikesEcharts',
          bikeType: 0 // 0-自行车，1-电动车
        })
      } else if (item.clickType === 3) {
        // 站点历史详情
        this.onShowDialog({
          ...item,
          type: 4,
          fromAmap: true
        })
      } else if (item.clickType === 5) {
        // 通过浮窗删除当前站点
        console.log(item)
        this.$router.push({
          name: 'deviceManagement',
          params: {
            id: this.selfAreaId,
            siteId: item.siteId
          }
        })
        // this.showConfirm(
        //   '温馨提示',
        //   '你是否确定删除“' + item.siteName + '”站点？',
        //   () => {
        //     this.handleDelDevice(item)
        //   },
        //   () => {}
        // )
      }
      this.clearMapTimer()
    },
    showConfirm(textTitle, text, successFn, failFn) {
      this.$confirm(text, textTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          successFn && successFn.call(this)
        })
        .catch(() => {
          failFn && failFn.call(this)
        })
    },
    handleDelDevice(item) {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId
      }
      const data = {
        siteId: item.siteId,
        areaId: item.areaId
      }
      Api.deleteDeviceSite(data, params).then((res) => {
        if (res.code === 200) {
          vm.$message.success('站点删除成功！')
          vm.refreshAddress()
          vm.changeCurrMap(item)
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    changeCurrMap(target) {
      let index = -1
      this.tableData.map.forEach((item, i) => {
        if (item.siteId === target.siteId) {
          index = i
        }
      })
      if (index !== -1) {
        this.tableData.map.splice(index, 1)
        this.$refs.myMap &&
            this.$refs.myMap.delSiteAndShowMap(this.tableData.map)
      }
    },
    refreshCenter(position) {
      const vm = this
      if (position) {
        const {
          lng: lon,
          lat
        } = position
        vm.mapCenterPosition = {
          lon,
          lat
        }
      }
    },
    refreshMap(position) {
      const vm = this
      if (position) {
        const {
          lng: lon,
          lat
        } = position
        const distance = 1000
        vm.mapCenterPosition = {
          lon,
          lat,
          distance
        }
        this.pollingMap(true)
      }
    },
    getGovCenter() {
      return new Promise((resolve, reject) => {
        AMap.plugin('AMap.Geocoder', () => {
          var geocoder = new AMap.Geocoder()
          geocoder.getLocation(this.selfAddress, (status, result) => {
            if (status === 'complete' && result.info === 'OK') {
              // 经纬度
              var lng = result.geocodes[0].location.lng
              var lat = result.geocodes[0].location.lat
              resolve({
                lng,
                lat
              })
            } else {
              console.log('定位失败!')
              resolve({
                lng: 0,
                lat: 0
              })
            }
          })
        })
      })
    },
    refreshAddress() {
      const vm = this
      const params = {
        selfAreaId: vm.globaleSelfAreaId,
        userAreaId: vm.globaleSelfAreaId
      }
      // 用户区域范围拉取
      params.areaId = vm.globaleSelfAreaId
      store
        .dispatch('user/setSideBarLoading', {
          value: true
        })
        .then(() => {})
      store.dispatch('user/getUserArea2', params).then(() => {
        store
          .dispatch('user/setSideBarLoading', {
            value: false
          })
          .then(() => {})
      })
    },
    changeWeeks(row) {
      const t = ` ${row.startHour}-${row.endHour}`
      const ws = row.week.split(',')
      const wsText = []
      for (let i = 0, len = ws.length; i < len; i++) {
        this.getWeekText(i, ws[i]) && wsText.push(this.getWeekText(i, ws[i]))
      }
      return `${wsText.length ? wsText.join(',') : ''}${t}`
    },
    getWeekText(week, weekValue) {
      if (weekValue === '1') {
        return {
          0: '星期天',
          1: '星期一',
          2: '星期二',
          3: '星期三',
          4: '星期四',
          5: '星期五',
          6: '星期六'
        }[week]
      }
      return false
    },
    // jjSearch 精准搜索
    jjSearch(item) {
      store.commit('user/setUserInfo', {
        key: 'siteId',
        value: ''
      })
      if (this.$refs.stationSearch && item.siteId) {
        this.$refs.stationSearch.siteSearch(item.siteId)
      } else if (this.$refs.stationSearch && item.bikeId) {
        this.$refs.stationSearch.search(item.bikeId)
      } else if (this.urlParams.siteName) {
        this.$refs.stationSearch.siteNameSearch(this.urlParams.siteName)
      }
      this.$refs['w-dialog'].onCloseDialog()
    },
    jjSearchFromHistory(item) {
      this.$refs.myMap.jjSearchFromHistory(item)
    },
    pageNoChange2(page) {
      this.formData2.pageNum = page
      this.handleSiteInfo()
    },
    pageSizeChange2(size) {
      this.formData2.pageSize = size
      this.handleSiteInfo()
    },
    siteReturnStatistics(params) {
      const vm = this
      return new Promise((resolve, reject) => {
        Api.siteReturnStatistics(params)
          .then((res) => {
            if (res.code === 200) {
              vm.siteReturnStatisticsData = res.data
              vm.companySelect = 99
              vm.companyOptions = []
              for (const key in vm.siteReturnStatisticsData) {
                vm.companyOptions.push({
                  value: key,
                  label: key
                })
              }
              // vm.translate(vm.companySelect)
              // vm.$refs['w-dialog2'].onShowDialog()
              resolve(true)
            } else {
              reject(new Error('the siteReturnStatistics has problom!'))
              vm.$message.warning(res.message)
            }
          })
          .catch((err) => {
            reject(new Error('the siteReturnStatistics has problom!'))
            console.log(err)
          })
      })
    },
    siteRentStatistics(params) {
      const vm = this
      return new Promise((resolve, reject) => {
        Api.siteRentStatistics(params)
          .then((res) => {
            if (res.code === 200) {
              vm.siteRentStatisticsData = res.data
              vm.companySelect = 99
              for (const key in vm.siteRentStatisticsData) {
                vm.companyRentOptions.push({
                  value: key,
                  label: key
                })
              }
              resolve(true)
            } else {
              reject(new Error('the siteRentStatistics has problom!'))
              vm.$message.warning(res.message)
            }
          })
          .catch((err) => {
            reject(new Error('the siteRentStatistics has problom!'))
            console.log(err)
          })
      })
    },
    async handleBikesEcharts() {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId,
        siteId: vm.siteInfoData.siteId,
        date: vm.getToday(vm.bikesEchartsData)
      }
      // await vm.siteReturnStatistics(params);
      // await vm.siteRentStatistics(params);
      // vm.translate(vm.companySelect);
      vm.$refs['w-dialog2'].onShowDialog()
    },
    companySelectChange(val) {
      this.translate(val)
    },
    translate(companySelect) {
      const vm = this
      const avgTime = []
      const avgPower = []
      const avgTimeRent = []
      const avgPowerRent = []
      vm.hourAndPower = {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
        21: 0,
        22: 0,
        23: 0,
        24: 0
      }
      vm.hourAndPowerRent = {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
        21: 0,
        22: 0,
        23: 0,
        24: 0
      }
      if (companySelect === 99) {
        for (const d in vm.siteReturnStatisticsData) {
          vm.siteReturnStatisticsData[d].forEach((item) => {
            vm.hourAndPower[item.hour] = vm.hourAndPower[item.hour] + item.num
          })
        }
        for (const d in vm.siteRentStatisticsData) {
          vm.siteRentStatisticsData[d].forEach((item) => {
            vm.hourAndPowerRent[item.hour] =
                vm.hourAndPowerRent[item.hour] + item.num
          })
        }
      } else {
        vm.siteReturnStatisticsData[companySelect].forEach((item) => {
          vm.hourAndPower[item.hour] = vm.hourAndPower[item.hour] + item.num
        })
        vm.siteRentStatisticsData[companySelect].forEach((item) => {
          vm.hourAndPowerRent[item.hour] =
              vm.hourAndPowerRent[item.hour] + item.num
        })
      }
      // console.log(111, vm.hourAndPower)
      for (const key in vm.hourAndPower) {
        avgTime.push(key)
        avgPower.push(vm.hourAndPower[key])
      }
      for (const key in vm.hourAndPowerRent) {
        avgTimeRent.push(key)
        avgPowerRent.push(vm.hourAndPowerRent[key])
      }
      const copyAvgPower = JSON.parse(JSON.stringify(avgPower)).sort(
        (a, b) => a - b
      )
      const copyAvgPowerRent = JSON.parse(JSON.stringify(avgPowerRent)).sort(
        (a, b) => a - b
      )
      const maxReturn = copyAvgPower[copyAvgPower.length - 1]
      const maxRent = copyAvgPowerRent[copyAvgPowerRent.length - 1]
      const maxData = {}
      let max = 0
      if (maxReturn > maxRent) {
        max = maxReturn
      } else if (maxReturn < maxRent) {
        max = maxRent
      } else {
        max = maxReturn
      }
      if (max <= 4) {
        maxData.max = 4
        maxData.splitNumber = 4
      } else if (max > 4 && max <= 8) {
        maxData.max = 8
        maxData.splitNumber = 4
      } else if (max > 8 && max <= 16) {
        maxData.max = 16
        maxData.splitNumber = 4
      } else if (max > 16 && max <= 30) {
        maxData.max = 30
        maxData.splitNumber = 6
      } else if (max > 30 && max <= 50) {
        maxData.max = 50
        maxData.splitNumber = 5
      } else if (max > 50) {
        maxData.max = max
        maxData.splitNumber = 5
      }
      const options = vm.getDrawLineParams(
        avgTime,
        avgPower,
        maxData,
        avgPowerRent
      )
      console.log('options', options)
      vm.$nextTick(() => {
        setTimeout(() => {
          vm.drawLine('echarts', options)
        }, 300)
      })
    },
    // avgPower 还车
    getDrawLineParams(avgTime, avgPower, maxData, avgPowerRent) {
      const options = {
        legend: {
          selectedMode: false,
          data: [{
            name: '还车数',
            textStyle: {
              color: 'rgba(255, 255, 255, 0.65)'
            }
          },
          {
            name: '租车数',
            textStyle: {
              color: 'rgba(255, 255, 255, 0.65)'
            }
          }
          ]
        },
        // x抽
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          data: avgTime, // this.getEveryDateStr(this.getWeekBefore(), this.getToday()),
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.65)'
            }
          }
        },
        // y轴
        yAxis: {
          type: 'value',
          name: '车辆数', // y轴名称
          scale: true,
          max: maxData.max,
          min: 0,
          splitNumber: maxData.splitNumber,
          boundaryGap: [0.2, 0.2],
          // y轴名称样式
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 12,
            color: 'rgba(255, 255, 255, 0.65)'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.65)'
            }
          },
          splitLine: {
            // 网格线
            lineStyle: {
              type: 'dashed' // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true // 隐藏或显示
          }
        },
        series: [{
          name: '还车数',
          type: 'bar',
          data: avgPower, // ['3', '2', '4', '4', '5', '100', '500'],
          color: '#1F8FFB'
        },
        {
          name: '租车数',
          type: 'bar',
          data: avgPowerRent, // ['3', '2', '4', '4', '5', '100', '500'],
          color: '#F6AD32'
        }
        ]
      }
      return options
    },
    drawLine(id, options) {
      this.charts = echarts.init(document.getElementById(id))
      this.charts.setOption({
        ...options,
        tooltip: {
          trigger: 'axis', // 触发类型，默认数据触发，见下图，可选为：'item' ¦ 'axis'
          showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
          hideDelay: 100, // 隐藏延迟，单位ms
          transitionDuration: 0.4, // 动画变换时间，单位s
          backgroundColor: '#021922', // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: '#333', // 提示边框颜色
          borderRadius: 4, // 提示边框圆角，单位px，默认为4
          borderWidth: 0, // 提示边框线宽，单位px，默认为0（无边框）
          padding: 5, // 提示内边距，单位px，默认各方向内边距为5，
          // 接受数组分别设定上右下左边距，同css
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            lineStyle: {
              // 直线指示器样式设置
              color: 'rgba(255, 255, 255, 0.85)',
              width: 2,
              type: 'solid'
            },
            shadowStyle: {
              // 阴影指示器样式设置
              width: 'auto', // 阴影大小
              color: 'rgba(0, 218, 218, 0.3)' // 阴影颜色
            }
          },
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '5%',
          right: '10%',
          bottom: '2%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        }
      })
      this.charts.on('click', function (data) {
        console.log(111, data)
      })
      const vm = this
      window.addEventListener('resize', function () {
        vm.charts.resize()
      })
    },
    getToday(date) {
      // 返回 '2020-08-14'
      const day2 = date ? new Date(date) : new Date()
      day2.setTime(day2.getTime())
      return (
        day2.getFullYear() +
          '-' +
          (day2.getMonth() < 9
            ? '0' + (day2.getMonth() + 1)
            : day2.getMonth() + 1) +
          '-' +
          (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate())
      )
    },
    handleSiteInfo() {
      const vm = this
      vm.needPagination2 = true
      // vm.dialogTitle2 = vm.siteInfoData.siteName
      if (vm.siteInfoData.brandId) {
        // 从消息区 查看 过来的
        const params = {
          selfAreaId: vm.selfAreaId,
          brandId: vm.siteInfoData.brandId,
          siteId: vm.siteInfoData.siteId,
          bikeType: vm.siteInfoData.bikeType,
          currentPage: vm.formData2.pageNum,
          pageSize: vm.formData2.pageSize
        }
        Api.getBrandSiteBike(params).then((res) => {
          if (res.code === 200) {
            vm.tableData2 = res.data.lists
            vm.total2 = res.data.total
            vm.subType = vm.siteInfoData.type
            vm.$refs['w-dialog2'].onShowDialog()
          } else {
            this.$message.warning(res.message)
          }
        })
      } else {
        // 从地图弹窗 电瓶车或者自行车 过来的
        console.log('// 从地图弹窗 电瓶车或者自行车 过来的')
        const params = {
          selfAreaId: vm.selfAreaId,
          bikeType: vm.siteInfoData.bikeType,
          siteId: vm.siteInfoData.siteId,
          currentPage: vm.formData2.pageNum,
          pageSize: vm.formData2.pageSize
        }
        Api.siteBike(params).then((res) => {
          if (res.code === 200) {
            vm.tableData2 = res.data.lists
            vm.total2 = res.data.total
            vm.subType = vm.siteInfoData.type
            vm.$refs['w-dialog2'].onShowDialog()
          } else {
            this.$message.warning(res.message)
          }
        })
      }
    },
    onShowDialog2(type) {
      const vm = this
      this.clearMapTimer()
      if (type === 'brandOperationNum') {
        // 运维人数
        vm.dialogTitle2 = '运维人员信息'
        vm.paramsType = 'maintain_person'
        if (this.detail.maintainPersonUrl) {
          downloadExcel(this.detail.maintainPersonUrl)
        } else {
          this.$message.warning('运维人员信息不存在！')
        }
        return false
      } else if (type === 'brandBikeNum') {
        // 核定自行车数
        vm.dialogTitle2 = '自行车信息'
        vm.paramsType = 'bicycle_excel'
        if (this.detail && this.detail.bicycleUrl) {
          downloadExcel(this.detail.bicycleUrl)
        } else {
          this.$message.warning('自行车信息不存在！')
        }
        return false
      } else if (type === 'brandEBikeNum') {
        // 核定电动车数
        vm.dialogTitle2 = '电动车信息'
        vm.paramsType = 'electric_vehicle_excel'
        if (this.detail.electricVehicleUrl) {
          downloadExcel(this.detail.electricVehicleUrl)
        } else {
          this.$message.warning('电动车信息不存在！')
        }
        return false
      } else if (type && type.type === 'bikes') {
        // 当前站点的车辆
        vm.siteInfoData = type
        vm.subType = type.type
        vm.dialogTitle2 =
            vm.siteInfoData && vm.siteInfoData.bikeType === 0
              ? '自行车车辆信息'
              : vm.siteInfoData && vm.siteInfoData.bikeType === 1
                ? '电动车车辆信息'
                : '车辆信息'
        vm.handleSiteInfo()
        return false
      } else if (type && type.type === 'bikesEcharts') {
        // 还车曲线图
        vm.siteInfoData = type
        vm.subType = type.type
        vm.dialogTitle2 = '车辆总数曲线图'
        vm.handleBikesEcharts()
        return false
      }
      vm.subType = type
      const params = {
        selfAreaId: vm.selfAreaId,
        brandId: vm.detail.brandId,
        type: vm.paramsType
      }
      Api.getEnterpriseInfoById(params).then((res) => {
        if (res.code === 200) {
          vm.tableData2 = res.data
          vm.$refs['w-dialog2'].onShowDialog()
        } else {
          this.$message.warning(res.message)
        }
      })
      this.$refs['w-dialog2'].onShowDialog()
    },
    handleClose2() {
      this.$refs['w-dialog2'].onCloseDialog()
      this.$nextTick(() => {
        this.needPagination2 = false
        this.siteInfoData = {}
        this.tableData2 = []
        this.bikeType = ''
        this.brand = ''
        this.brandId = ''
        this.bikesEchartsData = new Date()
        this.formData2.pageNum = 1
        this.formData2.pageSize = 10
      })
      this.clearMapTimer()
    },
    async onShowDialog(data) {
      console.log(data)
      this.detailSimple = data
      this.clearMapTimer()
      if (data.type === 3) {
        store.commit('globalVariable/save', {
          key: 'ratioSites',
          value: []
        })
        return
      }
      switch (data.type) {
        case 1: // 统计区 - 企业
          this.dialogTitle = '企业信息'
          this.currentComponent = 'text-list'
          await this.getCompanyData()
          await this.getDashboardInfo()
          this.getAddress()
          break
        case 2: // 统计区 - 查看
          this.dialogTitle = data ? data.brandName + '站点车辆分布' : ''
          this.currentComponent = 'table-list'
          this.typeName = 'site'
          break
        case 3: // 消息区 - 历史记录
          this.dialogTitle = '今日历史消息'
          this.currentComponent = 'history-list'
          this.typeName = 'history'
          break
        case 4: // 消息区 - 详情
          this.dialogTitle = data ? data.siteName + '站点消息详情' : ''
          this.currentComponent = 'message-list'
          this.typeName = 'message'
          break
        case 5: // 备案检测 - 详情
          this.dialogTitle = '备案检测'
          this.currentComponent = 'recordList'
          this.typeName = 'bikeMonitor'
          break
        case 6: // 站点排名
          this.dialogTitle = '站点排名'
          this.currentComponent = 'siteRank'
          this.typeName = 'siteRank'
          break
        case 7: // 未传数据车
          this.dialogTitle = '未传数据车'
          this.currentComponent = 'notupload'
          this.typeName = 'notupload'
          break
      }
      this.$refs['w-dialog'].onShowDialog()
    },
    getDashboardInfo() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId,
          brandId: vm.detailSimple.brandId
        }
        Api.getDashboardInfo(params).then((res) => {
          if (res.code === 200) {
            vm.detail = res.data
          } else {
            vm.$message.warning(res.message)
          }
          resolve()
        })
      })
    },
    getCompanyData() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId
        }
        Api.getEnterpriseList(params).then((res) => {
          if (res.code === 200) {
            vm.companyData = res.data.lists
          } else {
            vm.$message.warning(res.message)
          }
          resolve()
        })
      })
    },
    handleClose() {
      this.detail = {}
      this.dialogTitle = ''
      this.currentComponent = ''
      this.$refs['w-dialog'].onCloseDialog()
      this.clearMapTimer()
    },
    onSearch(data) {
      this.currMap = data
      // 查询时候停止刷新
      if (this.mapTimer) {
        clearTimeout(this.mapTimer)
      }
    },
    initData() {
      const vm = this
      // 3分钟更新地图
      vm.pollingMap()
      setTimeout(() => {
        vm.asyncApiDebounce(vm.asyncApi, vm) // asyncApiTimer
      }, 0)
    },
    asyncApiDebounce(method, context, delay) {
      if (this.asyncApiTimer) {
        clearTimeout(this.asyncApiTimer)
      }
      this.asyncApiTimer = setTimeout(function () {
        method.call(context)
      }, delay || 1500)
    },
    asyncApi(item) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      store.dispatch('user/getFullPileNum', params)
      vm.getMsgCounts()
    },
    getMsgCounts() {
      if (this.userLevel >= 2) {
        const vm = this
        const params = {
          selfAreaId: vm.selfAreaId
        }
        Api.getMsgCounts(params).then((res) => {
          if (res.code === 200) {
            vm.siteMessageLength = res.data
            const userSiteMessageLength = {
              key: 'siteMessageLength',
              value: vm.siteMessageLength
            }
            store.commit('user/setUserInfo', userSiteMessageLength)
          } else {
            vm.$message.warning(res.message)
          }
        })
      } else {
        const userSiteMessageLength = {
          key: 'siteMessageLength',
          value: 0
        }
        store.commit('user/setUserInfo', userSiteMessageLength)
      }
    },
    refreshSite() {
      // store.commit("user/setUserInfo", {
      //   key: "illegalBikes",
      //   value: [],
      // });
      this.illegalBikes = []
      this.companyOfIllegalBikeValue = ''
      this.size = 50
      this.clearMapTimer()
      this.pollingMap()
    },
    async pollingMap(isMovedMap, refresh = false, status = '') {
      const vm = this
      clearTimeout(vm.mapTimer)
      vm.mapTimer = null
      if (location.hash.indexOf(vm.selfAreaId) === -1) {
        clearTimeout(vm.mapTimer)
        return null
      }
      vm.tableLoading = true
      // f=1,动态参数,是否为首次渲染地图,当值为1时,lat与lon传入市政府经纬度.(fast)
      // limit=200,动态参数,控制返回的站点数量,默认返回50条.根据地图zoom控制该值.
      let params = {
        v: this.size == 0 ? 1 : 2, // v=2执行返回附近站点v=1旧逻辑
        limit: this.size,
        selfAreaId: vm.selfAreaId
      }
      if (this.size != 0) {
        if (this.isFirst) {
          // 如果第一次渲染取政府的经纬度
          vm.mapCenterPosition = await this.getGovCenter()
          params.f = 1
          params = Object.assign(params, vm.mapCenterPosition)
        } else if (vm.mapCenterPosition && this.size != 0) {
          params.f = 0
          params = Object.assign(params, vm.mapCenterPosition)
        }
      }
      Api.dashboard(params)
        .then((res) => {
          if (res.code === 200) {
            this.isFirst = false
            let mapsite = []
            if (vm.tableData && vm.tableData.map) {
              mapsite = [...vm.tableData.map]
            }
            vm.tableData = res.data
            if (this.abnormalType == 0) {
              this.illegalBikes = []
              if (res.data && res.data.map) {
                this.$emit('update:mapsite', res.data.map)
                vm.$refs.myMap &&
                    vm.$refs.myMap.initMap(res.data.map, null, null, isMovedMap)
              } else {
                vm.$refs.myMap &&
                    vm.$refs.myMap.initMap([], null, null, isMovedMap)
              }
            }
            if (status) {
              this.filterSite(status)
            }
            if (vm.urlParams.siteId) {
              vm.isFirst = false
              setTimeout(() => {
                vm.jjSearch({
                  siteId: vm.urlParams.siteId
                })
              }, 300)
            }
            if (res.data && res.data.statistical) {
              const statistical = res.data.statistical
              statistical.bike =
                  statistical.bike && statistical.bike.length > 10
                    ? res.data.statistical.bike.slice(0, 10)
                    : statistical.bike
              statistical.ebike =
                  statistical.ebike && statistical.ebike.length > 10
                    ? res.data.statistical.ebike.slice(0, 10)
                    : statistical.ebike
              statistical.eSiteNumTotal = res.data.statistical.ebike.reduce(
                (total, item) => total + item.siteNum,
                0
              )
              statistical.bSiteNumTotal = res.data.statistical.bike.reduce(
                (total, item) => total + item.siteNum,
                0
              )
              this.$emit('update:statistical', statistical)
            }
            this.$emit(
              'update:siteMessage',
              res.data.siteMessage && res.data.siteMessage.length > 5
                ? res.data.siteMessage.slice(0, 10)
                : res.data.siteMessage
            )
            store.commit('globalVariable/save', {
              key: 'siteMessage',
              value: res.data.siteMessage
            })
            console.log(new Date(), 111)
            clearTimeout(vm.mapTimer)
            vm.mapTimer = null
            console.log(vm.mapTimer, 'vm.mapTimerOne-----')
            // 频繁移动地图，防止每个移动都刷新地图，只取最后一次移动地图进行刷新
            vm.mapTimer = setTimeout(vm.pollingMap, 180000)
            if (vm.mapTimer) {
              vm.mapTimerArr.push(vm.mapTimer)
            }
            setTimeout(() => {
              if (vm.mapTimerArr.length > 1) {
                var max = Math.max(...vm.mapTimerArr)
                console.log(vm.mapTimerArr, 'mapTimerArr')
                console.log(max, 'max')
                vm.mapTimerArr.forEach(num => {
                  if (num !== max) {
                    clearTimeout(num)
                  }
                })
                vm.mapTimer = null
                vm.mapTimerArr = []
              }
            }, 170000)
            console.log(vm.mapTimer, 'vm.mapTimerTwo-----')
          } else {
            vm.$message.warning(res.message)
            vm.$refs.myMap && vm.$refs.myMap.initMap([])
          }
          vm.tableLoading = false
        })
        .catch((err) => {
          vm.tableLoading = false
          console.log(err)
        })
    },
    pageNoChange() {
      console.log('pageNoChange')
    },
    getAddress() {
      const vm = this
      if (vm.detail && vm.detail.areaId) {
        // 归属区域
        const params = {
          areaId: vm.detail.areaId,
          selfAreaId: vm.selfAreaId
        }
        Api.getUserArea(params).then((res) => {
          if (res.code === 200) {
            vm.$set(vm.detail, 'areaIdText', '')
            if (res.data.province && res.data.province.areaName) {
              vm.detail.areaIdText += res.data.province.areaName
            }
            if (res.data.city && res.data.city.areaName) {
              vm.detail.areaIdText += res.data.city.areaName
            }
            if (res.data.region && res.data.region.areaName) {
              vm.detail.areaIdText += res.data.region.areaName
            }
          }
        })
      }
      if (vm.detail && vm.detail.operationAreaId) {
        // 运营范围
        const params = {
          areaId: vm.detail.operationAreaId,
          selfAreaId: vm.selfAreaId
        }
        Api.getUserArea(params).then((res) => {
          if (res.code === 200) {
            vm.$set(vm.detail, 'operationAreaIdText', '')
            if (res.data.province && res.data.province.areaName) {
              vm.detail.operationAreaIdText += res.data.province.areaName
            }
            if (res.data.city && res.data.city.areaName) {
              vm.detail.operationAreaIdText += res.data.city.areaName
            }
            if (res.data.region && res.data.region.areaName) {
              vm.detail.operationAreaIdText += res.data.region.areaName
            }
          }
        })
      }
      if (vm.detail && vm.detail.launchArea) {
        // 投放范围
        const params = {
          areaId: vm.detail.launchArea,
          selfAreaId: vm.selfAreaId
        }
        Api.getUserArea(params).then((res) => {
          if (res.code === 200) {
            vm.$set(vm.detail, 'launchAreaText', '')
            if (res.data.province && res.data.province.areaName) {
              vm.detail.launchAreaText += res.data.province.areaName
            }
            if (res.data.city && res.data.city.areaName) {
              vm.detail.launchAreaText += res.data.city.areaName
            }
            if (res.data.region && res.data.region.areaName) {
              vm.detail.launchAreaText += res.data.region.areaName
            }
          }
        })
      }
    },
    clearMapTimer(state) {
      if (this.mapTimer || this.state == 'stop') {
        console.log('----------清除地图刷新成功！----------')
        clearTimeout(this.mapTimer)
        this.mapTimer = null
        // 重置定时器任务
        if (state) {
          this.state = state
        }
        if (this.state == 'stop') {
          // 暂停就清楚定时器
          return
        }
        this.mapTimer = setTimeout(this.pollingMap, 180000)
      }
    }
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
    if (this.asyncApiTimer) {
      clearTimeout(this.asyncApiTimer)
    }
    clearTimeout(this.mapTimer)
    this.mapTimer = null
  }
}

</script>

<style lang="less" scoped>
  .mapbox {
    width: 100%;
    height: 100%;
    position: relative;

    .top-right {
      position: absolute;
      top: 24px;
      right: 24px;
      z-index: 1000000;
      .stat {
        background: #06101D;
        border-radius: 4px;
        border: 1px solid #3E7878;
        color: #00DADA;

        img {
          vertical-align: sub;
          margin-right: 4px;
        }
      }
    }

    .bottom-left {
      position: absolute;
      left: 24px;
      bottom: 24px;
      z-index: 1000000;
      display: flex;
      flex-direction: column;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 4px;
      border: 1px solid rgba(62, 120, 120, 0.5);
      padding: 12px;

      label {
        margin: 0 0 8px 0 !important;
        background: #06101D;
        border-radius: 4px;
        border: 1px solid #3E7878;
        color: #00DADA;
        width: 130px;
        padding: 6px 0;
        line-height: 12px;
        font-size: 12px;
        text-align: center;
        height: auto;

        /deep/.el-radio__input {
          display: none;
        }

        /deep/.el-radio__label {
          padding: 0;
        }

        &.is-checked {
          background: #00DADA;

          /deep/.el-radio__label {
            color: #06101D;
          }
        }

        &:last-child {
          margin: 0 !important;
        }
      }
    }

    .bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      img:nth-child(1) {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1111;
      }

      img:nth-child(2) {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1111;
      }

      img:nth-child(3) {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1111;
      }

      img:nth-child(4) {
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 1111;
      }
    }
  }

  .mapbox {
    .station-search {
      position: absolute;
      top: 16px;
      left: 16px;
      z-index: 10002;
    }

    .bike-company,
    .right-icon {
      position: absolute;
      top: 16px;
      right: 16px;
      z-index: 10002;
      cursor: pointer;

      .el-select {
        /deep/input.el-input__inner {
          background: #06101d;
          border-color: #00dada;
          color: #00dada;
        }
      }
    }

    .right-icon {
      bottom: 34px;
      right: 30px;
      top: auto;
    }

    .message-wall {
      display: flex;
      padding: 0 8px;
      width: 100%;
      justify-content: space-between;
      position: absolute;
      align-items: flex-end;
      bottom: 8px;
      left: 0;
      z-index: 202;
      box-sizing: border-box;
      z-index: 10002;
    }

    .ratio-btns {
      padding: 8px 0;
      background: #fafafa;
      text-align: center;
      position: fixed;
      bottom: 0;
      width: calc(100% - 180px);
    }
  }

  .bikesEcharts-header {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(255, 255, 255, 0.85);

    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
    }

    .mr40 {
      margin-right: 40px;
    }
  }

  .text-right {
    /deep/ input {
      background: transparent;
      color: #00dada;
      border-color: #00dada;
    }

    /deep/.el-input__icon {
      color: #00dada;
    }
  }

  .el-select-dropdown__item {
    padding-left: 12px;
  }

  .mapbox-dialog-content {
    #echarts {
      width: 780px;
      height: 400px;
    }
  }

  .message-wall.w50p {
    width: 50%;
  }

  .ratio-error-text {
    font-size: 14px;
    color: #e6352c;
    line-height: 1;
    margin-bottom: 15px;
  }

  .sp-red {
    color: #ff5000;
  }

  .el-select-dropdown__item {
    color: rgba(0, 218, 218, 0.65);

    &.selected {
      color: #00dada;
    }

    &.hover,
    &:hover {
      background: #052430;
    }
  }

</style>

<style lang="less">
  .statbox {
    background: rgba(0, 0, 0, 0.7);
    border-radius: 4px;
    border: 1px solid rgba(62, 120, 120, 0.5);

    >div {
      display: flex;
      align-items: center;
      cursor: pointer;

      &:first-child {
        border-bottom: 1px solid rgba(62, 120, 120, 0.5);
        padding-bottom: 9px;

        &+div {
          padding-top: 9px;
        }
      }

      >span {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: 16px;
        color: #00DADA;
        font-size: 12px;

        &:first-child {
          background: #052430;
          border-radius: 4px;
          padding: 6px 10px;
          color: #00DADA;
          width: 80px;
        }
        &:nth-child(3){
          color:#ED462F
        }
         &:nth-child(4){
          color:#FF7C14
        }
         &:nth-child(5){
          color:#42C351
        }
         &:nth-child(6){
          color:#FFC900
        }
        &:nth-child(7){
          color:#1F8FFB
        }
      }
    }
  }

  .right-dark {
    background: #052430;
    border-radius: 4px;
    border: 1px solid #3e7878;
    color: rgba(255, 255, 255, 0.65);
    padding: 12px 0;

    .active {
      background: #06101d;
      color: #00dada;

      .el-icon-check {
        margin-left: 20px;
        display: inline-block;
      }
    }

    .el-icon-check {
      display: none;
    }

    p {
      padding: 0 12px;
      font-size: 14px;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #606266;
      height: 34px;
      line-height: 34px;
      box-sizing: border-box;
      cursor: pointer;
      color: rgba(0, 218, 218, 0.65);

      &:hover {
        background: #06101d;
        color: #00dada;
      }
    }
  }

  .dark-select {
    .el-select-dropdown {
      background: #052430;
      box-shadow: 0px 0px 8px 0px rgba(0, 218, 218, 0.3);
      border-radius: 4px;
      border: 1px solid #3e7878;

      .el-select-dropdown__item {
        text-align: left;

        &:hover,
        &.hover {
          background: #06101d;
        }
      }
    }
  }

  .i-dialog {
    background: #052430;
    box-shadow: 0px 0px 8px 0px rgba(0, 218, 218, 0.3);
    border-radius: 4px;
    border: 1px solid #3e7878;

    input {
      border: 1px solid #3e7878;
      background: transparent !important;
      color: rgba(255, 255, 255, 0.65);

      &:focus {
        border-color: #3e7878 !important;
      }
    }

    span.el-checkbox-button__inner {
      background-color: transparent !important;
      border-color: #3e7878 !important;
      color: #3e7878 !important;
    }

    .el-checkbox-button.is-checked {
      span.el-checkbox-button__inner {
        border-color: #00dada !important;
        color: #00dada !important;
      }
    }

    button {
      background: transparent !important;
      border: 1px solid #3e7878;
      color: #00dada;
    }

    .is-active {
      .el-radio-button__inner {
        color: #00dada;
        border-color: #00dada;
        background: transparent;
        box-shadow: -1px 0 0 0 #00dada;
        border-left-color: #00dada !important;
      }
    }

    .el-radio-button__inner {
      background: transparent;
      color: #3e7878;
      border-color: #3e7878;
    }

    .el-radio-button:first-child .el-radio-button__inner {
      border-left-color: #3e7878;
    }

    .list-text-box li {
      color: rgba(255, 255, 255, 0.65);

      span:last-child {
        color: rgba(255, 255, 255, 0.85);
      }
    }

    .el-tabs__nav-scroll {
      .el-tabs__item {
        color: rgba(0, 218, 218, 0.3);
      }

      .el-tabs__item.is-active {
        color: #00dada;
      }

      .el-tabs__active-bar {
        background-color: #00dada;
      }
    }

    .el-tabs__nav-wrap::after {
      background-color: rgba(255, 255, 255, 0.65);
    }

    .msg-box {
      border-color: rgba(255, 255, 255, 0.1);

      .box-header {
        span {
          color: rgba(255, 255, 255, 0.65);
        }

        .title {
          color: #279a9a;
        }
      }

      .box-body ul li {
        color: rgba(255, 255, 255, 0.85);
      }
    }

    .el-dialog__title {
      color: #00dada;
    }

    .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background-color: rgba(255, 255, 255, 0.1);
    }

    .el-table__header {
      .has-gutter tr th {
        background: #0c3444;
        color: #279a9a;
      }
    }

    .el-table {
      background: #052430;

      th,
      tr {
        background: #052430 !important;
        border-bottom-color: rgba(255, 255, 255, 0.1);

        &:hover td {
          background: #06101d !important;
        }

        td {
          color: rgba(255, 255, 255, 0.65);
          border-bottom-color: rgba(255, 255, 255, 0.1);
        }
      }
    }

    .el-pagination {

      .el-pagination__total,
      .el-pagination__jump {
        color: rgba(255, 255, 255, 0.65);
      }

      input {
        border: 1px solid #3e7878;
        background: transparent !important;
        color: rgba(255, 255, 255, 0.65);
      }

      button {
        background: transparent !important;
        border: 1px solid #3e7878;
        color: #00dada;
      }

      .el-pager {
        li {
          color: #00dada;
          background: transparent !important;
          border: 1px solid #3e7878;

          &.active {
            background: #00dada !important;
            border: 1px solid #00dada;
            color: #06101d !important;
          }
        }
      }
    }
  }

</style>
